import apiInstance from './common.api';

export const downloadCsvReportVoice = async (id: string, format?: 'csv' | 'xls') => {
  return await apiInstance.get('/api/front/live_report/record/export', {
    params: {
      id: id,
      format,
    },
    responseType: 'blob',
  });
};
export const downloadCsvReportChat = async (id: string, format?: 'csv' | 'xls') => {
  return await apiInstance.get('/api/front/c_live_report/chat/export', {
    params: {
      id: id,
      format,
    },
    responseType: 'blob',
  });
};
